<template>
    <div class="card card-default" :style="cardWidth">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            width: {default: '100%'}
        },

        computed: {
            cardWidth() {
                return `width: ${this.width}`;
            }
        }
    };
</script>
